export default __webpack_public_path__ + "static/media/planing-center-label.ae52ef89.svg";